module.exports = __webpack_public_path__ + "static/custom-mega-menu-banners-800-adb87eddd041a0eb89d86815a0c4a9f8.jpg";